module.exports = __webpack_public_path__ + "img/mission-mentoring-small.8ce4f7c2.svg";